<form (ngSubmit)="onSubmit()" [formGroup]="form" novalidate>
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <mat-icon>edit</mat-icon>
      Edit Account Code
    </h1>
  </section>
  <section mat-dialog-content>
    <mat-form-field>
      <mat-label>Account Code</mat-label>
      <input formControlName="account_id" matInput />
    </mat-form-field>
  </section>
  <section align="end" mat-dialog-actions>
    <button
      mat-button
      mat-dialog-close
      matTooltip="Cancel and close."
      type="button"
    >
      <mat-icon>cancel</mat-icon>
      Cancel
    </button>
    <button
      [disabled]="!form.valid"
      mat-button
      matTooltip="Save page."
      type="submit"
    >
      <mat-icon>save</mat-icon>
      Save
    </button>
  </section>
</form>
